import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { keyedMapSetter } from 'commons/vuex/map/map.js';

const getQuickSearch = (id) => ({
    quick_search_id: id,
    name: '',
    filters: [],
});

export const mutations = {
    [MUTATIONS.SET_QUICK_SEARCH]: keyedMapSetter(Vue, 'quick_search_id', getQuickSearch),

    [MUTATIONS.REMOVE_QUICK_SEARCH](state, queue_uuid) {
        Vue.delete(state, queue_uuid);
    },
};
